import type { APIData } from 'webapp-types';

import MetricLimitationBase from 'webapp/models-custom/metric-limitation/base';

// for more general info check MetricLimitationBase

// the raw data is that of a range (for its maxMultiplier), or the compare's own disabled / info
export default class MetricLimitationCompare extends MetricLimitationBase<APIData.Metrics.RangeLimitation> {
	get disabled(): boolean {
		return !!this.rawData?.disabled;
	}

	get infoText(): string {
		return this.rawData?.info?.message || '';
	}
}
